<template>
  <section>
    <div
      class="card d-flex flex-row p-0 position-relative shadow h-100"
      style="min-height:300px"
    >
      <span
        class="position-absolute badge badge-pills
        rounded-pill bg-yellow-500 text-gray-700 fw-bold"
        style="right: 10px; top:-10px"
      >
        + {{ price }} €
      </span>
      <div
        class="card-body text-center rounded-4 transition-shadow
        box-shadow-green-300 box-shadow-hover-green-300 overflow-hidden
        d-flex flex-column justify-content-around"
      >
        <v-highlight :product-id="contract.productId" />
        <div
          v-if="contract.productId === 16"
          class="text-truncate"
        >
          {{ formatAddress }}
        </div>
        <img
          :src="`${aws}/${extension.icon}${extension.enabled ? '-colored' : ''}.svg`"
          width="104px"
          height="70px"
          class="mx-auto"
        >
        <div class="lead fw-bold">
          {{ extension.name }}
        </div>
        <v-switch
          :key="keySwitch"
          :active="extension.enabled"
          class="d-flex mx-auto"
          @update="(value) => set(extension, value)"
        />
        <div class="small">
          {{ extension.description }}
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import { ui } from '@/mixins';
import formatter from '@/utils/_Strings';

import { Switch } from '@/components/common/input';
import ProductHighlight from '@/components/common/helpers/ProductHighlight.vue';

export default {
  components: {
    'v-switch': Switch,
    'v-highlight': ProductHighlight,
  },
  mixins: [ui],
  props: {
    contract: {
      type: Object,
      required: false,
      default: () => ({
        productId: 1,
        extensions: [],
      }),
    },
    extension: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      count: 0,
    };
  },
  computed: {
    aws: () => `${import.meta.env.VITE_AWS_STATIC}/widget/svg/edition`,
    price() {
      return parseFloat(this.extension.monthlyPremium || 0)
        .toFixed(2)
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ' ')
        .replace('.', ',');
    },
    keySwitch() {
      return `switch-${this.extension.id}-${this.extension.enabled}-${this.count}`;
    },
    formatAddress() {
      if (this.contract.productId === 16) {
        return formatter.addressFormatter(this.contract.risk.local);
      }
      return null;
    },
  },
  beforeDestroy() {
    this.ui_showModalCrossSell({ value: false, type: null });
  },
  methods: {
    async set(extension, isEnabled) {
      const { extensions } = this.contract;
      const oldList = [...extensions];
      const cancel = async () => {
        const subscription = await this.$store
          .dispatch('contract/updateSubscription', { path: 'extensions', value: oldList });
        await this.$store.dispatch('contracts/updateSubscription', subscription);
        this.$emit('update');
        this.count += 1;
      };
      const newList = extensions.map((elem) => {
        if (elem.id === extension.id) {
          return {
            ...elem,
            enabled: elem.id === extension.id && isEnabled,
          };
        }
        return elem;
      });
      if (isEnabled) {
        this.ui_showModalCrossSell({ value: true, type: null, cancel });
      }
      await this.$store.dispatch('contract/setSubscription', this.contract);
      const subscription = await this.$store
        .dispatch('contract/updateSubscription', { path: 'extensions', value: newList });
      await this.$store.dispatch('contracts/updateSubscription', subscription);
    },
  },
};
</script>
<style scoped>
.custom-truncate {
  overflow: hidden;
  white-space: nowrap;
  max-height: 22px;
  max-width: 100%;
}
</style>
